import apiService from './apiService';

class AdminService {
  async listRoles() {
    return apiService.get('/admin/roles');
  }

  async listDepartments() {
    return apiService.get('/admin/departments');
  }

  async searchUsers(email) {
    return apiService.get(`/admin/users?email=${encodeURIComponent(email)}`);
  }

  async getUserRoles(userId) {
    return apiService.get(`/admin/users/${userId}/roles`);
  }

  async assignRole(userId, role, departmentId = null) {
    const body = { role };
    if (departmentId) body.department_id = departmentId;
    return apiService.post(`/admin/users/${userId}/roles`, body);
  }
}

export default new AdminService();
